module.exports = __webpack_public_path__ + "assets/img/img_complete_point.5369ba6b.svg";